<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Tg70Td/tc-custom/9780300165517.jpg?1726574064385" alt="This image is the cover for the book Stumbling Giant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stumbling Giant
      </h1>
      <p class="bookDescription body article font2">
        <b>Can anything prevent China surpassing the United States and becoming the world’s superpower?</b><br/><br/>While dozens of recent books and articles have predicted the near-certainty of China’s rise to global supremacy, this book boldly counters such widely-held assumptions. Timothy Beardson brings to light the daunting array of challenges that today confront China, as well as the inadequacy of the policy responses. Threats to China come on many fronts, Beardson shows, and by their number and sheer weight these problems will thwart any ambition to become the world’s “Number One power.”<br/><br/>Drawing on extensive research and experience living and working in Asia over the last 35 years, the author spells out China’s situation: an inexorable demographic future of a shrinking labor force, relentless aging, extreme gender disparity, and even a falling population. Also, the nation faces social instability, a devastated environment, a predominantly low-tech economy with inadequate innovation, the absence of an effective welfare safety net, an ossified governance structure, and radical Islam lurking at the borders. Beardson’s nuanced, first-hand look at China acknowledges its historic achievements while tempering predictions of its imminent hegemony with a no-nonsense dose of reality.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy Beardson
      </h2>
      
      <p class="authorDescription body article"><B>Timothy Beardson</B> founded and ran Crosby Financial Holdings, at the time the largest independent investment bank in the Far East. He is a permanent resident of Hong Kong.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e17ca8e